import React from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';

const Wrapper = styled.div`
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
`;

const Top = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  transition: all .5s;

  ${media.mobile`
    height: 160px;
  `}
`;

const Circle = styled.div`
  position: absolute;
  top: -400px;
  left: 50%;
  transform: translateX(-50%);
  width: 4000px;
  height: 2500px;
  border: 500px solid ${props => props.color};
  border-radius: 50%;
  transition: all .5s;

  ${media.w800`
    width: 2500px;
  `}
  ${media.tablet`
    width: 3000px;
  `}
  ${media.mobile`
    width: 2300px;
    top: -430px;
  `}
`;

const BottomCircle = ({color}) => (
    <Wrapper>
      <Top>
        <Circle color={color}/>
      </Top>
    </Wrapper>
);

export default BottomCircle;



// WEBPACK FOOTER //
// ./src/components/Lookbook/TopCircle.js